import React from "react";
import { Checkbox, Popover, Button, Row, Col } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import classes from "./profile.module.css";

class CheckboxMenu extends React.Component {
  state = {
    text: "",
    icon: {},
    selectedItems: [],
  };

  componentDidMount = () => {
    if (this.props.value && this.props.value.length) {
      this.setState(
        {
          selectedItems: [...this.props.value],
          text: this.props.text,
        },
        () => this.checkIconFilled()
      );
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState(
        {
          selectedItems: [...this.props.value],
          text: this.props.text,
        },
        () => this.checkIconFilled()
      );
    }
  }

  onChange = (selection) => {
    this.setState({ selectedItems: [...selection] }, () => {
      this.checkIconFilled();
    });

    if (this.props.onChange) {
      this.props.onChange(selection);
    }
  };

  checkIconFilled = () => {
    if (this.state.selectedItems.length) {
      this.setState({ icon: { theme: "filled" } });
    } else {
      this.setState({ icon: {} });
    }
  };

  checkboxRender = () => {
    const { options } = this.props;
    const { selectedItems } = this.state;

    const allChecked = selectedItems.length === options.length;
    const isIndeterminate = selectedItems.length > 0 && !allChecked;

    const groups = options
      .map((e, i) => (i % 10 === 0 ? options.slice(i, i + 10) : null))
      .filter((e) => e);

    return (
      <>
        <Checkbox
          indeterminate={isIndeterminate}
          checked={allChecked}
          onChange={(e) => {
            const newSelection = e.target.checked ? [...options] : [];
            this.onChange(newSelection);
          }}
          style={{ marginBottom: 8 }}
        >
          Бүгдийг сонгох
        </Checkbox>
        <Checkbox.Group
          onChange={this.onChange}
          style={{ maxWidth: 500, maxHeight: 300, overflowY: "auto" }}
          value={selectedItems}
        >
          <Row>
            {groups.map((group, i) => (
              <Col
                key={"checkbox-group-" + i}
                span={Math.floor(24 / groups.length)}
              >
                {group.map((label) => (
                  <Checkbox
                    className={classes.checkbox}
                    key={label}
                    value={label}
                  >
                    {label}
                  </Checkbox>
                ))}
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </>
    );
  };

  render() {
    return (
      <Popover
        content={this.checkboxRender()}
        trigger="click"
        placement="bottomLeft"
        zIndex={100000}
      >
        <Button>
          {this.state.text} <FilterOutlined {...this.state.icon} />
        </Button>
      </Popover>
    );
  }
}

export default CheckboxMenu;
